import * as actionTypes from "Consts/actionsTypes";

const defaultListPageState = {
  loading: false,
  loadingAllCategories: false,
  loadMore: true,
  allCategories: [],
  items: [],
  categories: [],
  searchHitsText: "",
  initParams: false,
};

export const listpage = (state = defaultListPageState, action) => {
  switch (action.type) {
    case actionTypes.LISTPAGE__LOADING:
      state = {
        ...state,
        loading: action.payload,
      };
      break;
    case actionTypes.LISTPAGE__LOADINGCATEGORIES:
      state = {
        ...state,
        loadingAllCategories: action.payload,
      };
      break;
    case actionTypes.LISTPAGE__GETALLCATEGORIES:
      state = {
        ...state,
        allCategories: action.payload,
      };
      break;
    case actionTypes.LISTPAGE__GETITEMS:
      const { payload } = action;

      state = {
        ...state,
        items: payload.cleanresult
          ? payload.searchHits
          : [...state.items, ...payload.searchHits],
        loadMore: payload.loadMore,
        searchHitsText: payload.searchHitsText,
      };
      break;
    case actionTypes.LISTPAGE__SETCATEGORIES:
      state = {
        ...state,
        categories: action.payload,
        initParams: true,
      };
      break;
  }
  return state;
};
